module.exports = __webpack_public_path__ + "img/end_pic.8a3c456e.png";